import React, { useEffect, useMemo, useState } from "react";
import { useQuery } from "@tanstack/react-query";
import TablePage from "../../components/patientsList/genericTable/TablePage";
import "./DevicesModalTable.scss";
import { fetchAlldevices } from "../../common/api/deviceService"; // Replace with your actual service
import { organizeFotaDevicesTableData } from "../../common/function/organizeDeviceData";

interface DevicesModalTableProps {
  versionNumbers: any[]; // FOTA data passed from the parent
  isLoading: boolean; // Loading state passed from the parent
  onClose: () => void;
  // onPublish?: (selectedDevices: string[]) => void; // Pass selected devices on publish
  setOutsideSelectedDevices: React.Dispatch<React.SetStateAction<string[]>>;
  selectedDevices: string[];
}
enum SortKeysText {
  serialNumber = "Serial Number",
  creationDate = "Creation Date",
  SWVersion = "Version",
  relatedPatient = "Related Patient",
  siteName = "Center",
  relatedHCP = "Related HCP",
  status = "Status",
}
// Table sorting keys
const sortKeyArray = [
  "serialNumber",
  "creationDate",
  "SWVersion",
  "relatedPatient",
  "siteName",
  "relatedHCP",
  "status",
];
const DevicesModalTable: React.FC<DevicesModalTableProps> = ({
  versionNumbers,
  isLoading,
  onClose,
  // onPublish,
  setOutsideSelectedDevices,
  // selectedDevices,
}) => {
  const [sortKey, setSortKey] = useState<string>("serialNumber");
  const [sortOrder, setSortOrder] = useState<"ASC" | "DESC">("ASC");
  const [filters, setFilters] = useState<string[]>([]);
  const [selectedDevices, setSelectedDevices] = useState<string[]>([]);
  // Fetch devices using real API
  const { data: devicesData = [], isLoading: isDevicesLoading } = useQuery({
    queryKey: ["devices", filters, sortKey, sortOrder],
    queryFn: () => fetchAlldevices(sortKey, sortOrder, "", filters),
    // enabled: !isLoading,
  });
  useEffect(() => {
    setOutsideSelectedDevices([]);
  }, []);

  function updateOutsSideDevices(index: string) {
    setOutsideSelectedDevices((prev) => {
      const updated = prev.includes(index)
        ? prev.filter((item) => item !== devicesData[index].id)
        : [...prev, devicesData[index].id];
      return updated;
    });
  }

  // Handle row selection
  const toggleRowSelection = (id: string) => {
    updateOutsSideDevices(id);
    setSelectedDevices((prev) => {
      const updated = prev.includes(id)
        ? prev.filter((item) => item !== id)
        : [...prev, id];
      return updated;
    });
  };

  // Handle "Select All" checkbox
  const allSelected = useMemo(
    () =>
      devicesData.length > 0 && selectedDevices.length === devicesData.length,
    [selectedDevices]
  );
  const toggleSelectAll = () => {
    if (allSelected) {
      setSelectedDevices([]);
      setOutsideSelectedDevices([]);
    } else {
      setSelectedDevices(
        devicesData.map((device: any, index: number) => index.toString())
      );
      setOutsideSelectedDevices(devicesData.map((device: any) => device.id));
    }
  };



  function getFilters1(data: { site: string }[]) {
    // Get unique site values
    const uniqueSites = Array.from(
      new Set(data.map((device: any) => device.site))
    );
    return {
      center: [
        ...uniqueSites.map((site) => ({
          name: site,
          value: site,
        })),
      ],
    };
  }
  return (
    <TablePage
      customClass="modal-table-page-container"
      filterObj={getFilters1(organizeFotaDevicesTableData(devicesData))}
      cards={[]}
      trashAction={() => {}}
      hideHeader={true} // Header hidden for this modal
      tableData={organizeFotaDevicesTableData(devicesData)} // Pass organized data
      sortKeysArray={sortKeyArray.map((value) => ({
        name: SortKeysText[value],
        val: value,
      }))}
   
      setSortKey={setSortKey}
      sortKey={sortKey}
      sortOrder={sortOrder}
      setSortOrder={setSortOrder}
      setFilters={setFilters} // Pass filter handler
      filters={filters} // Current filters
      toggleRowSelection={(index) => toggleRowSelection(index.toString())} // Row selection handler
      toggleSelectAll={toggleSelectAll} // "Select All" handler
      allSelected={allSelected} // Pass "Select All" state
      showCheckbox={true} // Show checkboxes for rows
      selectedRows={selectedDevices} // Pass selected devices
    />
  );
};

export default DevicesModalTable;
